var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M28 15.75a8.75 8.75 0 00-8.75 8.75V35h3.5V24.5a5.25 5.25 0 1110.5 0V35h3.5V24.5A8.75 8.75 0 0028 15.75zm0-3.5A12.25 12.25 0 0015.75 24.5v12.25c0 .967.784 1.75 1.75 1.75h7a1.75 1.75 0 001.75-1.75V24.5a1.75 1.75 0 013.5 0v12.25c0 .967.784 1.75 1.75 1.75h7a1.75 1.75 0 001.75-1.75V24.5A12.25 12.25 0 0028 12.25zM1.75 15.75c0-.966.784-1.75 1.75-1.75h7c.966 0 1.75.784 1.75 1.75v21a1.75 1.75 0 01-1.75 1.75h-7a1.75 1.75 0 01-1.75-1.75v-21zm3.5 1.75V35h3.5V17.5h-3.5zM7 5.25a1.75 1.75 0 100 3.5 1.75 1.75 0 000-3.5zM1.75 7a5.25 5.25 0 1110.5 0 5.25 5.25 0 01-10.5 0z","fill":"#73808D"}));
}

Linkedin.defaultProps = {"width":"42","height":"42","fill":"none"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
